import styled from 'styled-components'

export const Textarea = styled.textarea<{valid: boolean}>`
  height: 200px;
  min-height: 30px;
  border: none;
  font-family: atomic___SanFranciscoMono, monospace;
  color: ${p => (p.valid ? p.theme.black : p.theme.red)};
  display: block;
  background: none;
  resize: vertical;
  padding: 20px;
  overflow: auto;
  white-space: pre;
  line-height: ${p => p.theme.lineHeight};
`

export const Label = styled.label`
  font-size: ${p => p.theme.fontSizeS};
  color: ${props => props.theme.grey50};
  display: flex;
  align-items: center;
  height: 30px;
  padding: 15px 20px 0;
`

export const Wrapper = styled.div<{hasLabel: boolean}>`
  display: block;
  background: ${p => p.theme.grey05};
  border-radius: 5px;
  position: relative;
  ${props => props.hasLabel && `textarea { padding-top: 5px; }`}
`
// useful in css rules
export const JSONFieldWrapper = Wrapper
